import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

const steps = [
  'PAN Verification',
  'Aadhar Verification',
  'Bank Details'
];

interface HorizontalStepperProps {
  activeStep: number;
}

function HorizontalStepper(props: HorizontalStepperProps): JSX.Element {
  return (
    <Box sx={{
      width: '100%',
      mb: '1rem',
      margin: 'auto', // Center the stepper
    }}>
      <Stepper activeStep={props.activeStep} alternativeLabel >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel 
            sx={{
              '& .MuiStepLabel-label': {
                fontSize: { xs: '0.75rem', sm: '1rem' }, // Responsive font size
                  fontWeight: 'bold', // Optional: make the text bold
              },
            }}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}

export default HorizontalStepper;